var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grey"},[_c('b-container',[_c('BlogPageControls',{attrs:{"blogId":_vm.blogId}})],1),_vm._v(" "),_c('AppFooter',{staticClass:"mt-5"}),_vm._v(" "),_c('PresentationCenter',{attrs:{"id":"presentation"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }